import { TImmunobiological } from "@/@types/esus/TImmunobiological";
import { esusApi } from "../api";

type Params = {
	uf: string;
	ibgeCode: string;
	cnes: string;
};

export async function getTImmunobiologicals({ uf, ibgeCode, ...params }: Params) {
	const { data } = await esusApi.get<TImmunobiological[]>(
		`/uf/${uf}/city/${ibgeCode}/TImmunobiological/GetImmunobiologicals`,
		params
	);
	return data || [];
}
